/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Cable = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M4 9a2 2 0 0 1-2-2V5h6v2a2 2 0 0 1-2 2Z" }],
    ["path", { d: "M3 5V3" }],
    ["path", { d: "M7 5V3" }],
    ["path", { d: "M19 15V6.5a3.5 3.5 0 0 0-7 0v11a3.5 3.5 0 0 1-7 0V9" }],
    ["path", { d: "M17 21v-2" }],
    ["path", { d: "M21 21v-2" }],
    ["path", { d: "M22 19h-6v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2Z" }]
  ]
];

export { Cable as default };
//# sourceMappingURL=cable.js.map
